const events = {
  ADD_PANEL_LOADED: 'addPanelLoaded',
  SET_CONTAINER_BEFORE: 'SET_CONTAINER_BEFORE',
  SAVE_PUBLISH_UNLOCKED: 'SAVE_PUBLISH_UNLOCKED',
};

export default {
  events,
};
